import React, { useState, useEffect, useRef, useMemo } from "react";
import styled, { css } from "styled-components";

import { theme } from "styles";
// components
import Text from "components/ui/Text";
import TextField from "components/ui/TextField";
import Popup from "components/ui/Popup";
import Button from "components/entrance/Button";
import EntranceTemplate from "components/entrance/entrance-template";

const FindPwTemplate = ({
  title,
  buttonOnClick,
  infoTitle = false,
  infoText = false,
  inputValue,
  inputValueChange,
  onClickBack,
  onClickAuth,
  authCount,
  setAuthCount,
}) => {
  const [open, setOpen] = useState(false);

  const inputValidation = useMemo(() => {
    const { phoneNumber, name } = inputValue;
    return [phoneNumber.length < 12, name.length < 1];
  }, [inputValue]);

  const handleClickAuth = async (count) => {
    onClickAuth(count, setOpen);
  };

  const handleKeyUp = (e) => {
    const keyCode = e.which ? e.which : e.keyCode;
    if (keyCode === 13) {
      e.target.blur();
      handleClickAuth(authCount);
    }
  };

  const TopContent = useMemo(() => {
    return (
      <>
        <WrapperInput>
          <TextField
            type="tel"
            maxLength="13"
            label="아이디"
            placeholder="휴대폰 번호를 입력해주세요"
            value={inputValue.phoneNumber}
            onChange={(e) => {
              inputValueChange(e, "phoneNumber");
            }}
            css={css`
              margin-bottom: 16px;
            `}
          />
          <TextField
            pattern={false}
            maxLength="50"
            label="이름"
            placeholder="이름을 입력해주세요"
            value={inputValue.name}
            onChange={(e) => inputValueChange(e, "name")}
            onKeyUp={handleKeyUp}
          />
        </WrapperInput>
      </>
    );
  }, [inputValue]);

  const BtmContent = useMemo(() => {
    return (
      <>
        {infoText && (
          <>
            <Text
              display="block"
              color="primary50"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              css={css`
                margin-bottom: 4px;
              `}
            >
              {infoTitle}
            </Text>
            <Text color="gray80" fontSize="14px">
              {infoText}
            </Text>
          </>
        )}

        <Button
          color={
            !inputValidation[0] && !inputValidation[1] ? "white" : "disable"
          }
          background={
            !inputValidation[0] && !inputValidation[1] ? "primary100" : "gray5"
          }
          onClick={
            !inputValidation[0] && !inputValidation[1]
              ? () => handleClickAuth(authCount)
              : () => {}
          }
        >
          인증요청
        </Button>
      </>
    );
  }, [open, inputValue, authCount, inputValidation]);

  return (
    <>
      <EntranceTemplate
        title={title}
        topContent={TopContent}
        btmContent={BtmContent}
        onClickBack={onClickBack}
      />
      <Popup open={open} onClose={setOpen}>
        <WrapperPopup>
          <Text
            fontWeight="600"
            lineHeight="20px"
            css={css`
              margin-bottom: 16px;
            `}
          >
            인증번호 입력
          </Text>
          <TextField
            type="tel"
            maxLength="6"
            label="인증번호"
            placeholder="인증번호를 입력해주세요"
            value={inputValue.authNumberFromUser}
            onChange={(e) => inputValueChange(e, "authNumberFromUser")}
            css={css`
              margin-bottom: 16px;
            `}
            authCount={authCount}
          />
          <Divider />
          <Button
            background="white"
            onClick={() => handleClickAuth(authCount)}
            css={css`
              border: 1px solid ${theme.colors["line30"]};
              height: 48px;
              margin-bottom: 32px;
              border-radius: 8px;
            `}
          >
            <Text color="gray80" lineHeight="20px">
              인증번호 재요청
            </Text>
          </Button>
          <WrapperInput>
            <TextField
              pattern={false}
              type="passwordWithEye"
              maxLength="100"
              label="새 비밀번호"
              placeholder="새 비밀번호를 입력해주세요"
              value={inputValue.passCode}
              onChange={(e) => inputValueChange(e, "passCode")}
              validation={inputValidation[0]}
              css={css`
                margin-bottom: 16px;
              `}
            />
            <TextField
              pattern={false}
              type="passwordWithEye"
              maxLength="100"
              label="새 비밀번호 확인"
              placeholder="새 비밀번호 다시 입력해주세요"
              value={inputValue.passCodeConfirm}
              onChange={(e) => inputValueChange(e, "passCodeConfirm")}
              validation={inputValidation[1]}
            />
          </WrapperInput>
          <div
            style={{
              marginTop: 24,
              marginBottom: 8,
              textAlign: "center",
              fontSize: "14px",
              color: "#26282B",
              fontWeight: 500,
            }}
          >
            비밀번호는 8자 이상 숫자와 영어를 포함해서 입력해주세요
          </div>
          <Button color="white" background="primary100" onClick={buttonOnClick}>
            비밀번호 변경하기
          </Button>
        </WrapperPopup>
      </Popup>
    </>
  );
};

const WrapperInput = styled.div`
  margin-top: 32px;
`;

const WrapperPopup = styled.div`
  margin-bottom: 17px;
`;

const Divider = styled.div`
  border-top: 1px solid ${theme.colors["line20"]};
  margin: 16px 0;
`;

export default FindPwTemplate;
